import { deleteData, fetchData,postData } from '@/utilities/API/apiUtility';

export async function GetSessionData(session) {
  var getSessionData  =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetSessionData;

    var sessionId = session.get('session-guid');

    if(sessionId != null && sessionId != undefined){

    getSessionData = getSessionData
    .replace("{sessionId}", sessionId);

  try {
    const response = await fetchData(getSessionData);
    
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("An error occurred while fetching the session data", error);
  }
}
}

export async function DeleteSessionData(session) {
  var deleteSessionData  =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_DeleteSessionData;

  if (session.get('session-guid') != null && session.get('session-guid') != undefined) {
    deleteSessionData = deleteSessionData
      .replace("{sessionId}", session.get('session-guid'));

    try {
      const response = await deleteData(deleteSessionData);

      if (response && response.status === 200) {
        session.remove('session-guid');
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.log("An error occurred while deleting the session data", error);
    }
  }
}

export async function AddEmailAddressInSession(emailAddress, session) {
  const AddSessionData =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddSessionData;

    var sessionId = session.get("session-guid");    

  const sessionData = {
    emailAddress: emailAddress,
    sessionId:sessionId != null & sessionId != undefined ? sessionId : ""
  };

  try {
    const postResponse = await postData(AddSessionData, sessionData);

    if (postResponse && postResponse.status === 200) {
      session.set("session-guid", postResponse.data.sessionId);
    } else {
      return null;
    }
  } catch (error) {
    console.log("An error occurred while saving the emai address in session data", error);
  }
}

export async function AddCustIdInSession(custId, session) {
  const AddSessionData =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddSessionData;

  const sessionData = {
    stripeCustId: custId,
    sessionId:session.get("session-guid")
  };

  try {
    const postResponse = await postData(AddSessionData, sessionData);

    if (!postResponse && postResponse.status !== 200) {
      return null;
    }
  } catch (error) {
    console.log("An error occurred while saving the stripe cust id in session data", error);
  }
}

export async function AddUIMIdInSession(uimId, session) {
  const AddSessionData =
    process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddSessionData;

  const sessionData = {
    uimId: uimId,
    sessionId:session.get("session-guid")
  };

  try {
    const postResponse = await postData(AddSessionData, sessionData);

    if (!postResponse && postResponse.status !== 200) {
      return null;
    }
  } catch (error) {
    console.log("An error occurred while saving the uim id in session data", error);
  }
}
